// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Utils
import { isApple } from '../../../utils/services/browser';

// Styles
import './ShortcutKey.scss';

export const convertKeyToEnvironment = (key) => {
    const str = key.toLowerCase();
    switch (str) {
        case 'ctrl':
            return 'ctrl';
        case '⌘':
        case 'cmd':
        case 'command':
            return isApple ? '⌘' : 'ctrl';
        case '⌥':
        case 'alt':
        case 'opt':
        case 'option':
            return isApple ? 'option' : 'alt';
        default:
            return key;
    }
};

export const convertKeyToEnvironmentSymbol = (key) => {
    const str = key.toLowerCase();
    switch (str) {
        case 'ctrl':
            return '⌃';
        case '⌘':
        case 'cmd':
        case 'command':
            return isApple ? '⌘' : '⌃';
        case '⌥':
        case 'alt':
        case 'opt':
        case 'option':
            return isApple ? '⌥' : 'alt';
        case 'shift':
            return '⇧';
        case 'return':
            return '⏎';
        case 'tab':
            return '⇥';
        default:
            return key;
    }
};

const shiftUp = (key) => {
    switch (key) {
        case '>':
        case '<':
            return true;
        default:
            return false;
    }
};

const ShortcutKey = ({ children, size = 'normal', preferSymbol = false }) => {
    const char = preferSymbol ? convertKeyToEnvironmentSymbol(children) : convertKeyToEnvironment(children);
    const title = char !== children ? children : null;

    const classes = classNames('ShortcutKey', `shortcut-${size}`, {
        char: char.length === 1,
        'shift-up': shiftUp(children),
    });

    return (
        <span className={classes} title={title}>
            {char}
        </span>
    );
};

ShortcutKey.propTypes = {
    children: PropTypes.string.isRequired,
    size: PropTypes.string,
    preferSymbol: PropTypes.bool,
};

export default ShortcutKey;
